function requireFormData(data){
  if(!data?.get||!data?.getAll)throw new TypeError('FormData-like value is required');
  return data;
}

function text(data,name){
  const value=data.get(name);
  return value==null?null:String(value).trim();
}

function list(data,name){
  return data.getAll(name).map(value=>String(value).trim()).filter(Boolean);
}

function nullableNumber(data,name){
  const value=text(data,name);
  if(value==null||value==='')return null;
  const number=Number(value);
  return Number.isFinite(number)?number:value;
}

export function onboardingInputFromForm(data,step){
  const form=requireFormData(data);
  if(step==='experience'){
    return Object.freeze({experienceLevel:text(form,'experience_level')});
  }
  if(step==='goals'){
    return Object.freeze({
      smokingGoals:Object.freeze(list(form,'smoking_goals')),
      otherText:text(form,'smoking-goal-other')||null
    });
  }
  if(step==='products'){
    return Object.freeze({
      productPreferences:Object.freeze(list(form,'product_preferences')),
      otherText:text(form,'product-preference-other')||null
    });
  }
  throw new TypeError('Unsupported onboarding step');
}

export function smokerInputFromForm(data){
  const form=requireFormData(data);
  return Object.freeze({
    name:text(form,'name')||'',
    smokerTypeKey:text(form,'smokerTypeKey')||null,
    notes:text(form,'notes')||null,
    fuelTypes:Object.freeze(list(form,'fuel_types')),
    minTemperatureCelsius:nullableNumber(form,'minTemperatureCelsius'),
    maxTemperatureCelsius:nullableNumber(form,'maxTemperatureCelsius'),
    coldSmoking:text(form,'coldSmoking')||'unknown',
    coldSmokeMaxCelsius:nullableNumber(form,'coldSmokeMaxCelsius'),
    temperatureControl:text(form,'temperatureControl')||'unknown',
    controlPrecisionCelsius:nullableNumber(form,'controlPrecisionCelsius')
  });
}

export function smokerPhotoInputFromForm(data){
  const form=requireFormData(data);
  if(text(form,'remove_photo')==='yes'){
    return Object.freeze({action:'remove'});
  }

  const file=form.get('photo');
  if(!file||typeof file!=='object'||Number(file.size||0)<=0)return null;

  return Object.freeze({
    action:'replace',
    file,
    mimeType:String(file.type||'').trim().toLowerCase(),
    sizeBytes:Number(file.size)
  });
}

export function thermometerInputFromForm(data){
  const form=requireFormData(data);
  return Object.freeze({
    name:text(form,'name')||'',
    typeKey:text(form,'typeKey')||'other',
    vendor:text(form,'vendor')||null,
    model:text(form,'model')||null,
    channelCount:nullableNumber(form,'channelCount')
  });
}

export function woodInputFromForm(data){
  const form=requireFormData(data);
  const source=text(form,'wood_source')||'catalogue';
  return Object.freeze({
    catalogueKey:source==='catalogue'?(text(form,'catalogueKey')||null):null,
    customName:source==='custom'?(text(form,'customName')||null):null,
    quantity:nullableNumber(form,'quantity'),
    quantityUnit:text(form,'quantityUnit')||null,
    notes:text(form,'notes')||null,
    available:text(form,'available')==='yes'
  });
}

export function woodFavouritePreferenceFromForm(data){
  const form=requireFormData(data);
  return text(form,'favourite')==='yes';
}

export function tastePreferencesFromForm(data,keys=[]){
  const form=requireFormData(data);
  const result={};
  for(const rawKey of keys||[]){
    const key=String(rawKey||'').trim();
    if(!key)continue;
    const value=text(form,key);
    if(value)result[key]=value;
  }
  return Object.freeze(result);
}
